<template>
  <form>
    <div class="row">
      <div class="col-md-5">
        <div>
          <label for="filename" class="form-label">File Name:</label>
          <input type="text" class="form-control" id="filename" v-model="product.productsParent.imageurl" />
        </div>

        <div class="mt-3">
          <label for="formFile" class="form-label">File:</label>
          <b-form-file v-model="UserFile" type="file" id="user-file" name="userfile" class="mt-1" accept="image/*" plain></b-form-file>
        </div>

        <div class="mt-3">
          <input type="submit" value="Upload small image file" class="btn btn-primary" @click="uploadSmallImage($event)" />
        </div>
      </div>
    </div>
  </form>
</template>
<script>
import Modal from '@/components/Modal.vue';

export default {
  name: 'UploadSmallImage',
  components: {
    appModal: Modal,
  },
  data() {
    return {
      UserFile: null,
    };
  },
  methods: {
    uploadSmallImage(e) {
      e.preventDefault();
      console.log(this.$route.params.Id);
      if (this.UserFile === null) {
        this.$store.dispatch('systemMessage/setModalMessage', {
          message: 'Select file',
        });
      }

      if (this.UserFile) {
        var formData = new FormData();
        var userFile = this.UserFile;

        formData.append('fileName', userFile);
        formData.append('productId', this.$route.params.Id);

        this.$store
          .dispatch('manageProducts/insertProductImage', formData)
          .then((status) => {
            this.UserFile = null;

            this.$store.dispatch('manageProducts/fetchProductById', {
              productId: this.$route.params.Id,
            });

            this.$store.dispatch('systemMessage/setModalMessage', {
              message: 'Image has been uploaded successfully.',
            });
          })
          .catch((err) => {
            console.log(err, 'error while uploading image');
          });
      }
    },
  },
  computed: {
    product() {
      return this.$store.state.manageProducts.product;
    },
  },
};
</script>
<style></style>
